export default __webpack_public_path__ + "img/tiny-28.24bb5688.jpg";